var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 3.3335C2.66602 2.80306 2.87673 2.29436 3.2518 1.91928C3.62687 1.54421 4.13558 1.3335 4.66602 1.3335H11.3327C11.8631 1.3335 12.3718 1.54421 12.7469 1.91928C13.122 2.29436 13.3327 2.80306 13.3327 3.3335V14.0188C13.3327 14.8322 12.4127 15.3055 11.7513 14.8328L7.99935 12.1528L4.24735 14.8328C3.58535 15.3062 2.66602 14.8328 2.66602 14.0195V3.3335Z",
    fill: "#774EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkPrimary);
export default __webpack_public_path__ + "static/media/bookmark_primary.9b4b9918293513d939d12ea4bf4c131f.svg";
export { ForwardRef as ReactComponent };